import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,Divider   } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalusercommentbacktbn from './Modalusercommentbacktbn';
import { URL,api } from '../api';
//import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';


export default class Commentbnlistforuser extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   iduser:'',
   commentuser:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
    //url:'https://git.kpru.ac.th/FrontEnd_Kprupsf/',
    
  
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_articlepsf,
                       iduser:this.props.id_emp,
         })
      setTimeout(() => {
       // api.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforuser.php?iduser='+this.props.iduser+'&id_send='+this.props.id_send)
        api.get('registercon/selectArticlespfbnwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf)
        .then(res => {
          console.log(res);
          this.setState({ commentuser: res.data})
         
        }) 
      }, 400);

  }


  list() {
      setTimeout(() => {
        api.get('registercon/selectArticlespfbnwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf)
        .then(res => {
          console.log(res);
          this.setState({ commentuser: res.data})
        
        }) 
      }, 0);
  }



    render() {
      //  console.log(this.state.id_bn)

        return (
            <>
          
     
{this.state.commentuser.length === 0 ?<>
<div className='text-center'><p>อยู่ระหว่างดำเนินการ</p></div>
</>:<>

 <MDBTable bordered responsive>
 <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ผลงาน</th>
          <th>ไฟล์ข้อเสนอแนะคณะกรรมการกลั่นกรอง</th>
          <th>ข้อเสนอแนะ</th>
          <th>ส่งกลับหลังปรับแก้ไข</th>
        
        </tr>
      </MDBTableHead>

      <MDBTableBody>
                          {this.state.commentuser.map((commentuser,index )  => 
                            <tr>
                            <td>{index+1}</td>

                            <td>{commentuser.send_uploadewordbn != null ? <>
                           
                               <tr>
                                  <th> <a href={`${this.state.url+commentuser.send_uploadewordbn}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF01</p> </a></th>
                                  <th> <a href={`${this.state.url+commentuser.send_uploadewordbn2}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF02</p> </a></th>
                                  <th> <a href={`${this.state.url+commentuser.send_uploadewordbn3}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF03</p> </a></th>
                                  <th> <a href={`${this.state.url+commentuser.send_uploadewordbn4}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF04</p> </a></th>
                                </tr>
                                 <tr>
                                  <th>  <a href={`${this.state.url+commentuser.send_uploadepdfbn}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF01</p> </a> </th>
                                  <th>  <a href={`${this.state.url+commentuser.send_uploadepdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF02</p> </a></th>
                                  <th>  <a href={`${this.state.url+commentuser.send_uploadepdfbn3}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF03</p> </a></th>
                                  <th>  <a href={`${this.state.url+commentuser.send_uploadepdfbn4}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF04</p> </a></th>
                                </tr>
                         
                           
                           
                           
                           
                            </>:<><MDBIcon far icon="hourglass" /></>}
                            </td>
                            
                            <td>{commentuser.send_uploadcommentepdfbn != null ? <>
                            <a href={`${this.state.url+commentuser.send_uploadcommentepdfbn}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a>
                            </>:<>
                            { commentuser.statusbn === '2' ?<> - </>:<> <MDBIcon far icon="hourglass" /></>}
                           
                            </>}</td>

                            <td>{commentuser.bn_commentbn !=null ?<>{commentuser.bn_commentbn}</>:<>{commentuser.statusbn === '2'?<>-</>:<><MDBIcon far icon="hourglass" /></>}</>}</td>
                           
                           
                            <td>
                              {commentuser.sentbackeditword != null ? <>
                              <a href={`${this.state.url+commentuser.sentbackeditword}`}  target="_blank"><p className="orange-text"><MDBIcon far icon="file-word" /> บทความที่ปรับแก้ไขแล้ว</p> </a>
                              </>:<> 
                                   
                                    {commentuser.statusbn ==='2'  ?<>ผ่าน</>:<>
                                     { commentuser.statusbn === '0' ?<> 
                                       <Modalusercommentbacktbn  id_articlepsf={commentuser.id_articlepsf} id_empbn={commentuser.id_empbn} nameuserbn={commentuser.nameuserbn} idarticlebn={commentuser.idarticlebn} list={this.list}/>
                                      </>:<>{commentuser.statusbn === '3' ?<>ส่งกลับแล้ว</>:<><MDBIcon far icon="hourglass" /> </>}</>} 
                                   </>}
                                     {/* 1 = ส่ง , 2 = ผ่าน , 0 = ปรับแก้  3 = ส่งกลับแล้ว*/}
                                     
                              
                               </>}
                            </td>

                          
                                  {/* <Modalexpercommentbacktbn id_send={commentbn.id_send} id_comment={commentbn.id_comment} id_bn={commentbn.id_bn} list={this.list}  /> */}
                                
                            </tr>
                          )}
          
          </MDBTableBody>
    </MDBTable>

</>}
   

   
           
          </>
          
        )
    }
}


